import { render, staticRenderFns } from "./MainLedgerCard3Selected.vue?vue&type=template&id=20d855a6"
import script from "./MainLedgerCard3Selected.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard3Selected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports